import styled, { css } from 'styled-components';
import { selectColor } from '@panel/commons';
import { withQuery } from '@panel/commons/core/themev2';

const ContainerLayout = styled.div`
  max-width: 1480px;
  margin: auto;
  margin-top: 30px;
  display: flex;
  gap: 40px;
  ${({ isDesktop }) =>
    !isDesktop &&
    css`
      flex-direction: column;
      padding: 16px;
      padding-bottom: 0;
    `}
  ${withQuery.lg.down()} {
    margin-top: ${({ portalWithTelBanner }) => (portalWithTelBanner ? '110' : '80')}px;
  }
`;

const LeftBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  ${({ isDesktop }) =>
    !isDesktop
      ? css`
          width: 100%;
        `
      : css`
          width: 290px;
          position: sticky;
          top: 40px;
        `}

  .separator {
    width: 100%;
    height: 1px;
    background-color: ${selectColor('grayMedium')};
  }
  @media screen and (max-width: 1530px) {
    margin-left: ${({ isDesktop }) => (!isDesktop ? 0 : 16)}px;
  }
`;

const Main = styled.div`
  width: ${({ device }) => (device !== 'desktop' ? 100 : 80)}%;
  margin-bottom: ${({ device }) => (device !== 'desktop' ? 0 : 64)}px;
  @media screen and (max-width: 1530px) {
    margin-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
  ${withQuery.xl.down()} {
    width: ${({ device }) => (device !== 'desktop' ? 100 : 75)}%;
  }
  @media screen and (max-width: 1330px) {
    padding-right: ${({ device }) => (device !== 'desktop' ? 0 : 16)}px;
  }
`;

const AlertContainer = styled.div`
  max-width: 1480px;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 19px;
  @media screen and (max-width: 1530px) {
    margin: 0 32px;
  }
  @media screen and (max-width: 1480px) {
    margin: 0 16px;
  }
`;

export { ContainerLayout, LeftBar, Main, AlertContainer };
